import { ContentType } from '@standardnotes/domain-core';
export class RemoveItemFromVault {
    constructor(mutator, sync, files) {
        this.mutator = mutator;
        this.sync = sync;
        this.files = files;
    }
    async execute(dto) {
        await this.mutator.changeItem(dto.item, (mutator) => {
            mutator.key_system_identifier = undefined;
            mutator.shared_vault_uuid = undefined;
        });
        await this.sync.sync();
        if (dto.item.content_type === ContentType.TYPES.File) {
            await this.files.moveFileOutOfSharedVault(dto.item);
        }
    }
}
